<template>
  <div>
    <div class="container px-6 mt-16">
      <h1 class="pl-0 text-lg font-bold md:px-4">
        <span class="text-pink-500">1.</span> {{ $t('messages.steps.personal_information') }}
      </h1>

      <div>
      </div>
      <div class="flex flex-wrap mt-6">
        <div
          class="w-full px-0 py-2 md:w-1/2 md:px-6"
          :class="{ 'form-group--error': errors.first('step1.firstname') }"
        >
          <label
            class="font-semibold"
            for=""
          >{{ $t('messages.step_one.name') }}</label>
          <input
            v-model="form.first_name"
            class="block w-full h-12 px-4 mt-2 font-semibold text-gray-700 border border-blue-500 rounded outline-none"
            type="text"
            name="firstname"
            placeholder="John Gregory"
            data-vv-scope="step1"
            :data-vv-as="$t('messages.step_one.name')"
            v-validate="'required|alpha_spaces|min:2'"
          >
          <ul>
            <li
              v-for="(error, index) in errors.collect('step1.firstname')"
              :key="index"
              class="mt-2 text-sm font-semibold text-red-500 is-danger"
            >
              {{ error }}
            </li>
          </ul>
          <span class="flex items-center h-auto mt-1 text-sm font-semibold text-blue-500">
            <svg
              width="20px"
              height="20px"
              viewBox="0 0 20 20"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              class="inline-block w-3 h-3 mr-2 text-blue-500 fill-current"
            >
              <path
                d="M2.92893219,17.0710678 C6.83417511,20.9763107 13.1658249,20.9763107 17.0710678,17.0710678 C20.9763107,13.1658249 20.9763107,6.83417511 17.0710678,2.92893219 C13.1658249,-0.976310729 6.83417511,-0.976310729 2.92893219,2.92893219 C-0.976310729,6.83417511 -0.976310729,13.1658249 2.92893219,17.0710678 Z M9,11 L9,10.5 L9,9 L11,9 L11,15 L9,15 L9,11 Z M9,5 L11,5 L11,7 L9,7 L9,5 Z"
                id="Combined-Shape"
              ></path>
            </svg>
            {{ $t('messages.step_one.indication_name') }}
          </span>
        </div>
        <div
          class="w-full px-0 py-2 md:w-1/2 md:px-6 "
          :class="{'form-group--error': errors.first('step1.lastname') }"
        >
          <label
            class="font-semibold"
            for=""
          >{{ $t('messages.step_one.last_name') }}</label>
          <input
            v-model="form.last_name"
            class="block w-full h-12 px-4 mt-2 font-semibold text-gray-700 border border-blue-500 rounded outline-none"
            type="text"
            name="lastname"
            placeholder="Doe Smith"
            data-vv-scope="step1"
            v-validate="'required|min:2'"
            :data-vv-as="$t('messages.step_one.last_name')"
          >
          <ul>
            <li
              v-for="(error, index) in errors.collect('step1.lastname')"
              :key="index"
              class="mt-2 text-sm font-semibold text-red-500 is-danger"
            >
              {{ error }}
            </li>
          </ul>
        </div>
        <div
          class="w-full px-0 py-2 md:w-1/2 md:px-6"
          :class="{'form-group--error': errors.first('step1.userEmail')}"
        >
          <label
            class="font-semibold"
            for=""
          >{{ $t('messages.step_one.email') }}</label>
          <input
            ref="subscriptionEmail"
            v-model="form.email"
            class="block w-full h-12 px-4 mt-2 font-semibold text-gray-700 border border-blue-500 rounded outline-none"
            type="email"
            name="userEmail"
            placeholder="doe.john@gmail.com"
            data-vv-scope="step1"
            :readonly="readonly"
            v-validate="'required|email|unique_email|blocked_email'"
            :data-vv-as="$t('messages.step_one.email')"
          >
          <ul>
            <li
              v-for="(error, index) in errors.collect('step1.userEmail')"
              :key="index"
              class="mt-2 text-sm font-semibold text-red-500 is-danger"
            >
              {{ error }}
            </li>
          </ul>
        </div>
        <div
          class="w-full px-0 py-2  md:w-1/2 md:px-6"
          :class="{'form-group--error': errors.first('step1.username')}"
        >
          <label
            class="font-semibold"
            for=""
          >{{ $t('messages.step_one.username') }}</label>
          <input
            v-model="form.username"
            class="block w-full h-12 px-4 mt-2 font-semibold text-gray-700 border border-blue-500 rounded outline-none"
            type="text"
            name="username"
            placeholder="Dreamer10, Britin23, Togetherforever"
            data-vv-scope="step1"
            autocomplete="offf"
            :readonly="readonly"
            v-validate="{
              required: true,
              unique_username: true,
              regex: /^[a-zA-Z0-9_-]{4,24}$/,
            }"
            :data-vv-as="$t('messages.step_one.username')"
            v-blockuser
          >
          <ul>
            <li
              v-for="(error, index) in errors.collect('step1.username')"
              :key="index"
              class="mt-2 text-sm font-semibold text-red-500 is-danger"
            >
              {{ error }}
            </li>
          </ul>
          <span class="flex items-center h-auto mt-1 text-sm font-semibold text-blue-500">
            <svg
              width="20px"
              height="20px"
              viewBox="0 0 20 20"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              class="inline-block w-3 h-3 mr-2 text-blue-500 fill-current"
            >
              <path
                d="M2.92893219,17.0710678 C6.83417511,20.9763107 13.1658249,20.9763107 17.0710678,17.0710678 C20.9763107,13.1658249 20.9763107,6.83417511 17.0710678,2.92893219 C13.1658249,-0.976310729 6.83417511,-0.976310729 2.92893219,2.92893219 C-0.976310729,6.83417511 -0.976310729,13.1658249 2.92893219,17.0710678 Z M9,11 L9,10.5 L9,9 L11,9 L11,15 L9,15 L9,11 Z M9,5 L11,5 L11,7 L9,7 L9,5 Z"
                id="Combined-Shape"
              ></path>
            </svg>
            {{ $t('messages.step_one.indication_username') }}
          </span>
        </div>
        <div
          class="w-full px-0 py-2 md:w-1/2 md:px-6 "
          :class="{'form-group--error': errors.first('step1.password')}"
        >
          <label
            class="font-semibold"
            for=""
          >{{ $t('messages.step_one.password') }}</label>
          <input
            v-model="form.password"
            class="block w-full h-12 px-4 mt-2 font-semibold text-gray-700 border border-blue-500 rounded outline-none"
            type="password"
            name="password"
            placeholder="Ctimber23!"
            data-vv-scope="step1"
            :readonly="readonly"
            v-validate="'required|min:8|max:32|strong_password'"
            :data-vv-as="$t('messages.step_one.password')"
            ref="password"
          >
          <span class="mt-2 text-sm font-semibold text-red-500 is-danger">
            {{ errors.first('step1.password') }}
          </span>
          <span class="flex items-center h-auto mt-1 text-sm font-semibold text-blue-500">
            <svg
              width="20px"
              height="20px"
              viewBox="0 0 20 20"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              class="inline-block w-3 h-3 mr-2 text-blue-500 fill-current"
            >
              <path
                d="M2.92893219,17.0710678 C6.83417511,20.9763107 13.1658249,20.9763107 17.0710678,17.0710678 C20.9763107,13.1658249 20.9763107,6.83417511 17.0710678,2.92893219 C13.1658249,-0.976310729 6.83417511,-0.976310729 2.92893219,2.92893219 C-0.976310729,6.83417511 -0.976310729,13.1658249 2.92893219,17.0710678 Z M9,11 L9,10.5 L9,9 L11,9 L11,15 L9,15 L9,11 Z M9,5 L11,5 L11,7 L9,7 L9,5 Z"
                id="Combined-Shape"
              ></path>
            </svg>
            {{ $t('messages.step_one.indication_password') }}
          </span>
        </div>
        <div
          class="w-full px-0 py-2 md:w-1/2 md:px-6 "
          :class="{'form-group--error': errors.first('step1.repeatPassword')}"
        >
          <label
            class="font-semibold"
            for=""
          >{{ $t('messages.step_one.confirm_password') }}</label>
          <input
            v-model="form.repeatPassword"
            class="block w-full h-12 px-4 mt-2 font-semibold text-gray-700 border border-blue-500 rounded outline-none"
            type="password"
            name="repeatPassword"
            placeholder="Ctimber23!"
            data-vv-scope="step1"
            :data-vv-as="$t('messages.step_one.confirm_password')"
            :readonly="readonly"
            v-validate="'required|confirmed:password'"
          >
          <ul>
            <li
              v-for="(error, index) in errors.collect('step1.repeatPassword')"
              :key="index"
              class="mt-2 text-sm font-semibold text-red-500 is-danger"
            >
              {{ error }}
            </li>
          </ul>
        </div>
        <div
          class="w-full px-0 py-2 md:px-6 "
          :class="{'form-group--error': errors.first('step1.message_profile')}"
        >
          <label
            class="font-semibold"
            for=""
          >{{ $t('messages.step_one.profile_message') }}</label>
          <input
            v-model="form.message_profile"
            class="block w-full h-12 px-4 mt-2 font-semibold text-gray-700 border border-blue-500 rounded outline-none"
            type="text"
            name="message_profile"
            data-vv-scope="step1"
            :data-vv-as="$t('messages.step_one.profile_message')"
            v-validate="'required|max_words:10'"
            v-block
            v-blockemojis
          >
          <span class="flex items-center h-auto mt-1 text-sm font-semibold text-blue-500">
            <svg
              width="20px"
              height="20px"
              viewBox="0 0 20 20"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              class="inline-block w-3 h-3 mr-2 text-blue-500 fill-current"
            >
              <path
                d="M2.92893219,17.0710678 C6.83417511,20.9763107 13.1658249,20.9763107 17.0710678,17.0710678 C20.9763107,13.1658249 20.9763107,6.83417511 17.0710678,2.92893219 C13.1658249,-0.976310729 6.83417511,-0.976310729 2.92893219,2.92893219 C-0.976310729,6.83417511 -0.976310729,13.1658249 2.92893219,17.0710678 Z M9,11 L9,10.5 L9,9 L11,9 L11,15 L9,15 L9,11 Z M9,5 L11,5 L11,7 L9,7 L9,5 Z"
                id="Combined-Shape"
              ></path>
            </svg>
            {{ $t('messages.step_one.indication_description') }}
          </span>
          <ul>
            <li
              v-for="(error, index) in errors.collect('step1.message_profile')"
              :key="index"
              class="mt-2 text-sm font-semibold text-red-500 is-danger"
            >
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
      <h1 class="pl-0 mt-6 text-lg font-bold text-blue-500 md:px-4 ">
        {{ $t('messages.step_one.birthdate') }}
      </h1>
      <v-date-picker
        v-model="form.birthday"
        :format="format"
        :start="maxStartDate"
        :end="maxEndDate"
        vvscope="step1"
        @changeDate="storeDate"
        :isEmpty="true"
        class=""
      ></v-date-picker>
      <div class="flex flex-wrap mt-2 lg:">
        <div class="w-full py-2 md:w-1/2 pox-0 md:px-6">
          <label
            class="font-semibold"
            for=""
          >{{ $t('messages.step_one.country') }}</label>
          <SelectInput
            @selected="setSelectedCountry"
            @typing="clearCity"
            :withimages="true"
            itemkey="id"
            imagekey="url"
            namekey="name"
            :disabled="hasCity"
            placeholder="Portugal"
            vvclass="form-group--error"
            vvscope="step1"
            vvname="country"
            :vvdata="$t('messages.step_one.country')"
            :require="true"
            :items="orderedCOuntries"
            :locale="locale"
            hasLocale
            sorted
          />
        </div>
        <div class="w-full px-0 py-2 md:w-1/2 md:px-6">
          <label
            class="font-semibold"
            for=""
          >{{ $t('messages.step_one.city') }}</label>
          <SelectInput
            @selected="setSelectedCity"
            :withimages="false"
            itemkey="name"
            namekey="name"
            vvclass="form-group--error"
            vvscope="step1"
            vvname="city"
            :vvdata="$t('messages.step_one.city')"
            :require="true"
            :items="cities"
            :selecteditem="form.city"
          />
        </div>
        <div class="w-full px-0 py-2 md:w-1/2 md:px-6">
          <label
            class="font-semibold"
            for=""
          >{{ $t('messages.step_one.phone') }}</label>
          <vue-tel-input
            v-model="form.phone_mobile"
            v-bind="phoneProps"
            :dynamicPlaceholder="true"
            v-validate="'required|unique_phone_mobile'"
            :data-vv-as="$t('messages.step_one.phone')"
            class="items-center block w-full h-12 p-2 px-4 mt-2 font-semibold text-gray-700 border border-blue-500 rounded"
            autocomplete="offf"
          >
          </vue-tel-input>
          <ul>
            <li
              v-for="(error, index) in errors.collect('telephone')"
              :key="index"
              class="mt-2 text-sm font-semibold text-red-500 is-danger"
            >
              {{ error }}
            </li>
          </ul>

          <span class="flex items-center h-auto mt-1 text-sm font-semibold text-blue-500">
            <svg
              width="20px"
              height="20px"
              viewBox="0 0 20 20"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              class="inline-block w-3 h-3 mr-2 text-blue-500 fill-current"
            >
              <path
                d="M2.92893219,17.0710678 C6.83417511,20.9763107 13.1658249,20.9763107 17.0710678,17.0710678 C20.9763107,13.1658249 20.9763107,6.83417511 17.0710678,2.92893219 C13.1658249,-0.976310729 6.83417511,-0.976310729 2.92893219,2.92893219 C-0.976310729,6.83417511 -0.976310729,13.1658249 2.92893219,17.0710678 Z M9,11 L9,10.5 L9,9 L11,9 L11,15 L9,15 L9,11 Z M9,5 L11,5 L11,7 L9,7 L9,5 Z"
                id="Combined-Shape"
              ></path>
            </svg>
            {{ $t('messages.step_one.verify_phone') }}
          </span>
        </div>

        <div class="w-full px-0 py-2 md:w-1/2 md:px-6">
          <label class="font-semibold">{{ $t('messages.step_one.postal_code') }}</label>
          <input
            v-model="form.zip_code"
            class="block w-full h-12 px-4 mt-2 font-semibold text-gray-700 border border-blue-500 rounded"
            type="text"
            data-vv-scope="step1"
            :data-vv-as="$t('messages.step_one.postal_code')"
            name="zip_code"
            placeholder="1011"
          >
          <ul>
            <li
              v-for="(error, index) in errors.collect('step1.zip_code')"
              :key="index"
              class="mt-2 text-sm font-semibold text-red-500 is-danger"
            >
              {{ error }}
            </li>
          </ul>
        </div>
      </div>
      <div class="flex flex-col w-full px-0 my-4 lg:flex-row md:px-6">
        <div class="flex flex-wrap w-full lg:w-1/2">
          <div class="w-full pr-0 md:w-1/2 md:pr-6 lg:pr-6">
            <p class="mb-2 text-sm font-semibold lg:text-base color-black">{{ $t('messages.general.i_am') }}</p>
            <div class="dropdown">
              <div class="relative w-full">
                <div
                  @click.prevent="isOpen = !isOpen"
                  class="w-full text-white font-semibold h-10 rounded py-3 px-4 text-xs border-none cursor-pointer"
                  :class="[picked.value === 'female' ? 'bg-gradient-pink' : 'bg-gradient-blue']"
                >
                  <p v-if="picked === ''">Genero</p>
                  <div v-else>
                    <i
                      :class="[picked.icon, 'text-white']"
                      class="mx-2"
                    ></i>
                    {{ $t(`messages.general.${picked.text}`) }}
                  </div>
                </div>
                <div
                  class="absolute z-50 w-full bg-gray-200"
                  v-show="isOpen"
                >
                  <label
                    class="text-gray-700 py-2 px-4 bg-gray-300 block hover:bg-gray-400 cursor-pointer"
                    v-for="(item, index) in genre"
                    :key="index"
                    :for="index"
                    @click.self="isOpen = !isOpen"
                  >
                    <input
                      type="radio"
                      class="hidden"
                      name="gender"
                      :id="index"
                      :value="item"
                      v-model="picked"
                    >
                    <i :class="item.icon"></i>
                    {{ $t(`messages.general.${item.text}`) }}
                  </label>
                </div>

              </div>
              <div class="absolute flex items-center px-2 pointer-events-none pin-y pin-r text-grey-darker"></div>
            </div>
          </div>
          <div class="w-full pr-0 md:w-1/2 md:pr-6 lg:pr-6">
            <p class="mb-2 text-sm font-semibold lg:text-base color-black">{{ $t('messages.search.interested') }}</p>
            <div class="flex justify-center text-xs items-center rounded h-10 text-white"
            :class="[picked.value === 'female' ? 'bg-gradient-blue' : 'bg-gradient-pink']">
              <i
                :class="icon_genre"
                class="mx-4"
              ></i>
              <p
                class="w-full font-semibold leading-tight rounded"
                v-text="$t(`messages.general.${res_genre}`)"
              ></p>
            </div>
          </div>
        </div>
        <div class="w-full px-2 py-4 mb-4 lg:w-1/2 md:pl-4">
          <p class="mb-4 text-sm font-semibold lg:text-base">{{ $t('messages.general.age_range') }}</p>
          <div class="px-0 md:px-4 slider-alter">
            <vue-slider
              v-model="range_slide.range_age"
              :tooltip="'always'"
              :tooltip-placement="['bottom', 'bottom']"
              :enable-cross="false"
              :min="18"
              color="#333"
            >
              <template v-slot:dot="{ value, focus }">
                <div :class="['custom-dot', { focus }]"></div>
              </template>
              <template v-slot:tooltip="{ value, focus }">
                <div
                  :class="['custom-tooltip', { focus }]"
                  class="font-semibold"
                >
                  {{ value }}
                </div>
              </template>
            </vue-slider>
          </div>
        </div>
      </div>
      <div class="px-0 md:px-6">
        <label class="mt-4 text-sm font-semibold leading-relaxed text-justify text-gray-600 checkbox">
          <span v-html="$t('messages.step_one.terms')"></span>
          <input
            type="checkbox"
            v-model="form.terms"
            name="terms"
            data-vv-scope="step1"
            :data-vv-as="$t('messages.step_one.terms_and_conditions')"
            v-validate="'required'"
          >
          <span class="bg-transparent border border-blue-400 border-solid checkmark" />
        </label>
        <ul>
          <li
            v-for="(error, index) in errors.collect('step1.terms')"
            :key="index"
            class="mt-2 text-sm font-semibold text-red-500 is-danger"
          >
            {{ error }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import "vue-tel-input/dist/vue-tel-input.css";
import VueTelInput from "vue-tel-input";
import VDatePicker from "@/components/VDatePicker.vue";
import Question from "@/components/Question.vue";
import SelectInput from "@/components/SelectInput.vue";
import bus from "@/bus";

export default {
  name: "RegisterStepOne",
  components: {
    VDatePicker,
    Question,
    VueTelInput,
    SelectInput
  },
  data: () => ({
    isOpen: false,
    format: "YYYY.MM.DD",
    date: "1991.10.01",
    vvScope: "step1",
    readonly: false,
    phoneProps: {
      defaultCountry: "",
      disabledFetchingCountry: false,
      disabled: false,
      disabledFormatting: false,
      placeholder: "7789 4567",
      enabledCountryCode: false,
      enabledFlags: true,
      preferredCountries: ["SV", "US"],
      onlyCountries: [],
      ignoredCountries: [],
      autocomplete: "on",
      name: "telephone",
      maxLen: 25,
      wrapperClasses: "",
      inputClasses: "",
      dropdownOptions: {
        disabledDialCode: false
      },
      inputOptions: {
        showDialCode: false
      },
      validCharactersOnly: true
    },
    options: [
      { icon: "icon-woman", text: "Mujer", value: "female" },
      { icon: "icon-man", text: "Hombre", value: "male" }
    ],
    range_slide: {
      range_age: [18, 100]
    },
    form: {
      gender: "female"
    },
    res_genre: "Hombre",
    res_genre: "men",
    icon_genre: "icon-man",
    picked: {
      id: 1,
      icon: "icon-woman",
      text: "woman",
      value: "female",
      match: "men"
    },
    genre: [
      {
        id: 1,
        icon: "icon-woman",
        text: "woman",
        value: "female",
        match: "men"
      },
      {
        id: 2,
        icon: "icon-man",
        text: "man",
        value: "male",
        match: "women"
      }
    ],
    orderedCOuntries: [],
    cities: [],
    hasCity: false
  }),
  watch: {
    locale() {
      this.$nextTick(() => {
        this.errors.items.forEach(e => {
          if (e.regenerate) {
            e.msg = e.regenerate();
          }
        });
      });
    },
    isOpen(isOpen) {
      if (isOpen) {
        document.addEventListener("click", this.closeDropdown);
      }
    },
    picked(val) {
      if (val.value === "male") {
        this.res_genre = "women";
        this.icon_genre = "icon-woman";
        this.form.gender = "male";
      } else if (val.value === "female") {
        this.res_genre = "men";
        this.form.gender = "female";
        this.icon_genre = "icon-man";
      }

      bus.$emit('choosed-gender', this.form.gender);
    }
  },
  mounted() {
    if (Object.keys(this.$route.params).length > 1) {
      this.range_slide.range_age = this.$route.params.range_age;
      this.picked = this.$route.params.picked;
    }
  },
  async created() {
    await this.getQuestions();
    await this.listCountries();

    this.orderedCOuntries = this.countries
      .filter(country => !!country.url)
      .slice();

    bus.$on('email-verification', (status) => {
      this.readonly = status;
    });
  },
  computed: {
    ...mapState("questions", ["questions"]),
    ...mapState("answer", ["answers"]),
    ...mapState("countries", ["countries"]),
    ...mapState("locale", ["locale"]),
    hasCountry() {
      return this.cities.length ? false : true;
    },
    maxEndDate() {
      const dt = new Date();
      // currentYear - min range age (18) = maxEnd year
      // concatenated with last day of the year, which is december(12) 31
      let day = dt.getDate();
      let month = dt.getMonth()+1;
      return dt.getFullYear() - 18 + `.${month}.${day}`;
    },
    maxStartDate() {
      const dt = new Date();
      return dt.getFullYear() - this.range_slide.range_age[1] + ".01.01";
    }
  },

  methods: {
    ...mapActions("questions", ["getQuestions"]),
    ...mapActions("answer", ["saveAnswersForm"]),
    ...mapActions("countries", ["listCountries", "countryCities"]),
    async setSelectedCountry(country) {
      this.cities = country ? await this.countryCities(country) : [];
      this.$set(this.form, "country_id", country);
      this.clearCity();
    },
    setSelectedCity(city) {
      this.$set(this.form, "city", city);
      this.hasCity = !!city;
    },
    clearCity() {
      this.$set(this.form, "city", null);
      this.hasCity = false;
    },
    changeAnswer(event) {
      this.saveAnswersForm({
        type: event.target.name,
        field: event.target.value
      });
    },
    getData() {
      this.form.range = this.range_slide.range_age;
      return this.form;
    },
    storeDate(value) {
      this.form.birthday = value;
    },
    closeDropdown() {
      if (!event.target.closest(".dropdown")) {
        this.isOpen = false;
      }
    }
  }
};
</script>
<style lang="scss">
.form-group--error input,
.form-group--error textarea,
.form-group--error select,
.form-group--error input:focus,
.form-group--error input:hover {
  border-color: #f79483;
}

.bg-gradient-blue {
  background: linear-gradient(90deg, #1C4C91 0%, #3A91F9 100%);
}

.bg-gradient-pink {
  background: linear-gradient(90deg, #F98296 4.19%, #D8406C 100%);
}

.steps-wrapper {
  .step {
    .circle {
      i[data-v-3ee86246] {
        background-color: #f35a78 !important;
      }
    }
  }
}
.custom-dot {
  width: 16px;
  height: 16px;
  border-radius: 100%;
  background-color: #D8406C;
  transition: all 0.3s;
}
.custom-dot:hover {
  transform: rotateZ(45deg);
  cursor: pointer;
}
.custom-dot.focus {
  border-radius: 50%;
}

.slider-alter {
  .vue-slider-rail {
      background-color: #dddddd !important;
  }
}

.vue-tel-input {
  border: 1px solid #0669f9 !important;
  & > .dropdown {
    padding: 0;
  }
}
</style>
